"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useEnum = exports.useEnums = void 0;
const react_1 = require("react");
const config_1 = require("./config");
class MissingEnumException extends Error {
}
/**
 * Retrieves the entire enum state.
 */
function useEnums() {
    const service = (0, config_1.getService)();
    const [state, setState] = (0, react_1.useState)(service.getState());
    (0, react_1.useEffect)(() => {
        const subscriber = (nextState) => {
            setState(nextState);
        };
        service.subscribe(subscriber);
        return () => {
            service.unsubscribe(subscriber);
        };
    }, []);
    return state;
}
exports.useEnums = useEnums;
/**
 * Retrieves a single enum from the state.
 *
 * @param enumName
 */
function useEnum(enumName) {
    const { enums } = useEnums();
    const enumValues = enums[enumName];
    if (enumValues) {
        return enumValues;
    }
    else {
        throw new MissingEnumException(`@42.nl/spring-enum: The enum named '${enumName}' could not be found, make sure the enums are loaded before the using them and that the '${enumName}' enum actually exists.`);
    }
}
exports.useEnum = useEnum;
